export function assignForwardedRef(forwardedRef, el) {
  if (forwardedRef) {
    if (typeof forwardedRef === 'function') {
      forwardedRef(el);
    } else {
      forwardedRef.current = el;
    }
  }
}
